import { render, staticRenderFns } from "./CreatePrivateSpace.vue?vue&type=template&id=5bf70987"
import script from "./CreatePrivateSpace.vue?vue&type=script&lang=js"
export * from "./CreatePrivateSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports